export default __webpack_public_path__ + "static/media/sec4.d3d563e1.jpeg";